import dynamic from "next/dynamic";
import ProductCardsGridConfig from "./product-cards-grid-config";
import ProductCardsGridAdvancedConfig from "./product-cards-grid-advanced-config";
const ProductCardsGridComponent = dynamic(()=>import("./product-cards-grid-component"));
export default {
    ProductCardsGridComponent,
    ProductCardsGridConfig,
    ProductCardsGridAdvancedConfig
};
